import { render, staticRenderFns } from "./AppGol.vue?vue&type=template&id=6637a48c&"
import script from "./AppGol.vue?vue&type=script&lang=js&"
export * from "./AppGol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports